// extracted by mini-css-extract-plugin
export var body = "_2q-1";
export var bodyPadded = "_2q-2";
export var chevron = "_2q-4";
export var chevronOpen = "_2q-5";
export var header = "_2q-0";
export var icon = "_2q-3";